import axios from "axios"
import { useContext, useEffect, useState } from "react"
import { getEnvConfig } from "../env"
import { Context } from "../store/store"
import ElemInput from "./elements/Input"

const SimpleCaptcha = ({ callback }) => {
	const env = getEnvConfig()
	const { globalState, dispatch } = useContext(Context)

	const [captchaIdent, setCaptchaIdent] = useState<string>("")
	const [captchaImg, setCaptchaImg] = useState<any>("")
	const [isCaptchaInvalid, setIsCaptchaInvalid] = useState<boolean>(false)
	const [captchaValue, setCaptchaValue] = useState<string>("")

	function captcheInputChange(e) {
		setCaptchaValue(e.target.value)
	}

	const toDataURL = url => {
		return fetch(url)
			.then(response => {
				response.headers.forEach(function (value, key) {
					if (key === "x-captcha-ident") {
						setCaptchaIdent(value)
					}
					if (key === "session-id") {
						dispatch({
							type: "SET_ENTRY",
							key: "sessionID",
							value: value,
						})
					}
				})

				return response.blob()
			})
			.then(
				blob =>
					new Promise((resolve, reject) => {
						const reader = new FileReader()
						reader.onloadend = () => resolve(reader.result)
						reader.onerror = reject
						reader.readAsDataURL(blob)
					})
			)
	}

	useEffect(() => {
		reloadCaptcha()
		// eslint-disable-next-line
	}, [])

	function reloadCaptcha() {
		let sessionId = ""
		if (globalState.sessionID) {
			sessionId = "&sessionId=" + globalState.sessionID
		}
		toDataURL(env.apibase + "captcha.php?cv=" + Date.now() + sessionId).then(dataUrl => {
			setCaptchaImg(dataUrl)
		})
	}

	function submitCaptcha(e) {
		e.preventDefault()
		const formdata = new FormData()

		formdata.append("captchaIdent", captchaIdent)
		formdata.append("sessionID", globalState.sessionID)
		formdata.append("captcha", captchaValue)

		axios
			.post(env.apibase + "captchaSolve.php?cv=" + Date.now(), formdata, {
				headers: {
					"content-type": "multipart/form-data",
					Accept: "application/json",
				},
			})
			.then(res => {
				//console.log(res)
				if (res.data.externalIdentifier) {
					setIsCaptchaInvalid(false)
					callback(res.data.externalIdentifier)

					try {
						const win: any = window
						win.dataLayer = win.dataLayer || []
						win.dataLayer.push({ event: "n2_mitspielen", sto_form_submit: true, sto_form_message: "captcha richtig" })
					} catch (error) {}
				} else {
					setIsCaptchaInvalid(true)
					reloadCaptcha()
					try {
						const win: any = window
						win.dataLayer = win.dataLayer || []
						win.dataLayer.push({ event: "n2_mitspielen", sto_form_submit: false, sto_form_message: "captcha ungueltig" })
					} catch (error) {}
				}
			})
			.catch(err => {
				console.error(err)
				setIsCaptchaInvalid(true)
				reloadCaptcha()
				callback(false)

				try {
					const win: any = window
					win.dataLayer = win.dataLayer || []
					win.dataLayer.push({ event: "n2_mitspielen", sto_form_submit: false, sto_form_message: "captcha ungueltig" })
				} catch (error) {}
			})
	}

	return (
		<form autoComplete="off" onSubmit={submitCaptcha} className="container pb-6 lg:pb-12">
			{/* {(window.location.host === "int.fe.nimm2-der-sommer-lacht-fe.campaign-loyalty.com" || window.location.host === "localhost") && (
				<div className="text-center my-8 max-w-md mx-auto">
					<select
						name="merchant"
						value={globalState.testActionCode || ""}
						onChange={e => {
							dispatch({
								type: "SET_ENTRY",
								key: "testActionCode",
								value: e.target.value,
							})
						}}
					>
						<option value="">normal raffle</option>
						<option value="0">PRIZE_BLANK</option>
						<option value="1">Montag - Produktpaket</option>
						<option value="2">Dienstag - Liegestuhl</option>
						<option value="3">Mittwoch - Strandtasche</option>
						<option value="4">Donnerstag - Produktpaket</option>
						<option value="5">Freitag - Koffer</option>
						<option value="6">Samstag - Luftmatratze</option>
						<option value="7">Sonntag - Decke</option>
					</select>
				</div>
			)} */}

			<div className=" mb-6 max-w-[450px] mx-auto">
				<div className="mb-4 font-Museo grid grid-cols-2 gap-4 items-center">
					<div>{captchaImg && <img src={captchaImg} className="rounded-lg w-full" alt="Captchaimage" />}</div>
					<div className="text-xl leading-xl font-Museo text-white pb-3">
						<div className="text-xs sm:text-xl underline cursor-pointer" onClick={reloadCaptcha}>
							Captcha neu laden
						</div>
					</div>
				</div>

				<ElemInput
					label={"Captcha Code eingeben*"}
					props={{
						value: captchaValue,
						required: "required",
						minLength: 2,
						maxLength: 10,
						onChange: captcheInputChange,
						id: "captcha",
						name: "captcha",
						type: "text",
					}}
					hasError={isCaptchaInvalid}
					className="col-span-2 md:col-span-1"
					errMsg="Bitte Captcha korrekt eingeben. Bitte Groß- und Kleinschreibung beachten."
				/>
			</div>

			<div className="max-w-[750px] mx-auto">
				<div className="text-right text-white text-xs h-0 font-Museo">*Pflichtfeld</div>
				<div className="text-center">
					<button className="btn">absenden</button>
				</div>
			</div>
		</form>
	)
}

export default SimpleCaptcha
